import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Badge, Button, Stack, Tooltip } from '@mui/material';
import React, { memo } from 'react';
import * as SX from './sx';
import { type QuickInfoButtonProps as Props } from './types';

export const QuickInfoButton = memo(
  ({
    className,
    data,
    badge,
    icon,
    iconSx,
    iconSize = 18,
    onSelect,
    id,
    disabled,
    tooltipText,
    hideBadge,
    buttonProps,
  }: Props<PeopleTableInfo>) => {
    const isDisabled =
      typeof disabled === 'function' ? disabled?.(data) : disabled;
    const showBadge = !hideBadge?.(data) && !isDisabled;
    const badgeData = badge(data);

    const handleClick = (e: React.BaseSyntheticEvent) => {
      onSelect(e.currentTarget, data, id);
    };

    return (
      <Tooltip title={isDisabled && tooltipText} placement="bottom">
        <Button
          className={classnames('QuickInfoButton', className)}
          sx={SX.root}
          disabled={isDisabled}
          disableRipple
          variant={isDisabled ? 'text' : 'contained'}
          {...buttonProps}
        >
          <Stack gap={1} alignItems="center">
            <Badge
              invisible={!showBadge}
              onClick={handleClick}
              variant={badgeData.variant ?? 'soft'}
              badgeContent={
                badgeData.text ? (
                  badgeData.text
                ) : (
                  <Icon
                    name={badgeData.icon ?? 'questionMark'}
                    sxx={badgeData.iconSx}
                  />
                )
              }
              color={badgeData.color}
              size={16}
            >
              <Icon
                name={icon}
                size={iconSize}
                sxx={iconSx}
                onClick={handleClick}
              />
            </Badge>
          </Stack>
        </Button>
      </Tooltip>
    );
  }
);

QuickInfoButton.displayName = 'QuickInfoButton';
